import { memo, PropsWithoutRef, useCallback } from 'react'

import { Delete } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import { SmepWorkspace } from '@nativewaves/nw-cloud-sdk/smep'
import { Row, Table } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { useWorkspaceDeleteMutation } from 'hooks/mutations/smep'
import { useConfirm } from 'hooks/utils'

type SelectionToolbarActionProps = {
  selectedRows: Row<SmepWorkspace>[]
  tableInstance: Table<SmepWorkspace>
}

const SelectionToolbarActionsRaw = ({ selectedRows, tableInstance }: PropsWithoutRef<SelectionToolbarActionProps>) => {
  const { t } = useTranslation(['common', 'domain'])

  const confirm = useConfirm()

  const { mutateAsync: deleteWorkspace } = useWorkspaceDeleteMutation()

  const handleDeleteSelectedWorkspaces = useCallback(async () => {
    try {
      await confirm(t('domain:Workspace.deleteSelected'))

      await Promise.allSettled(selectedRows.map((row) => deleteWorkspace({ workspaceId: row.original.id })))

      tableInstance.resetRowSelection()
    } catch (_) {}
  }, [confirm, deleteWorkspace, selectedRows, t, tableInstance])

  return (
    <Box sx={{ ml: 'auto', mr: 2, display: 'flex', alignItems: 'center', columnGap: 1 }}>
      <Tooltip title={t('deletionSuccess')} placement="top">
        <IconButton sx={{ ml: 'auto', mr: 2, my: 'auto' }} size="medium" onClick={handleDeleteSelectedWorkspaces}>
          <Delete fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export const SelectionToolbarActions = memo(SelectionToolbarActionsRaw)
